<template>
<div class="row goals">

	<div v-if="!goals.length" class="col-12 d-flex justify-content-center align-items-center my-4">
		<div class="rounded-circle circle-cropped avatar-xl bg-secondary text-white text-5xl text-center">
    		<i class="fad fa-trophy-alt fa-fw"></i>
    	</div>
    	<div class="ml-4 text-left">
	    	<div class="font-weight-bold text-2xl text-gray-700 leading-tight">Add a goal</div>
	    	<div class="font-lg text-gray-500 mb-2">Track progress for yourself or others</div>
	    	<router-link :to="{ name: 'goals.index' }" class="btn btn-primary">Create Goal</router-link>
	    </div>
    </div>

	<div v-for="goal in goals" class="goal_wrapper">
		<div class="goal" style=""> <!-- add a class if last? -->
			<div class="card-header pb-25 px-0 pt-0 mb-3 d-flex align-items-center">
				<span v-if="goal.goal_type == 'charge'" class="flex-grow-1">Charges Goal <i class="fal fa-wallet"></i></span>
	            <span v-else-if="goal.goal_type == 'referral'" class="flex-grow-1">Referrals Goal <i class="fal fa-user-injured"></i></span>
	            <span v-else class="flex-grow-1">Check-ins Goal <i class="fal fa-check-circle"></i></span>
			</div>

			<div>
                <div class="d-flex align-items-center mb-3">
                    <div class="rounded-circle circle-cropped avatar-sm mr-2 text-center bg-gray-100 text-gray-500">
                        <img v-if="goal.scope === 'user'" :src="user.photo_url" class="img-fluid">
                        <i v-else class="fal fa-hospital"></i>
                    </div>
                    <div class="flex-grow-1 text-blue-600 text-lg font-weight-bold">{{ goal.title }}</div>
                </div>

                <div class="d-flex">
                    <div class="flex-grow-1">
                        <template v-if="goal.active_goal_segment">
                            <div class="mb-2 text-sm text-uppercase text-gray-700">
                                {{ moment(goal.active_goal_segment.start_date).format('MMM D') }} - {{ moment(goal.active_goal_segment.end_date).format('MMM D') }}
                            </div>
                            <span class="text-4xl leading-tight">{{ goal.goal_type == 'charge' ? numeral(goal.active_goal_segment.matching_checkins).format('$0a') : goal.active_goal_segment.matching_checkins }}</span>
                            <span class="text-2xl text-gray-500"> / {{ goal.goal_type == 'charge' ? numeral(goal.target).format('$0a') : goal.target }}</span>
                        </template>

                        <template v-else>
                            <div class="mb-2 text-sm text-uppercase text-gray-700">
                                Progress not available
                            </div>
                            <span class="text-4xl leading-tight">--</span>
                            <span class="text-2xl text-gray-500"> / {{ goal.target }}</span>
                        </template>

                        <div class="text-gray-500">
                            {{ goal.frequency == 'day' ? 'Daily ' : goal.frequency == 'week' ? 'Weekly ' : 'Monthly ' }}
                            <span v-if="goal.goal_type == 'referral'" v-html="'Patient Referrals'" />
                            <span v-if="goal.goal_type == 'charge'" v-html="'Generated Charges'" />
                            <span v-if="goal.goal_type == 'checkin'" v-html="'Check-ins'" />
                            <span v-if="goal.goal_type == 'service_line'" v-html="'Check-ins promoting ' + goal.service_lines[0].label" />
                            <span v-if="goal.goal_type == 'specialty'" v-html="'Check-ins with ' + goal.specialties[0].label" />
                            <span v-if="goal.goal_type == 'checkin_type'" v-html="'Check-ins of type ' + goal.checkin_type.label" />
                        </div>
                    </div>
                    
                    <goal-item-donut v-if="goal.active_goal_segment" :segment="goal.active_goal_segment" class="ml-2" />
                </div>    
			</div>
		</div>
	</div>
</div>
</template>

<script>

	import { mapState } from 'vuex';
	import GoalItemDonut from './GoalItemDonut'

	export default {
		props: ['goals'],

		components: {
			GoalItemDonut,
		},

		computed: {
			...mapState(['user'])
		}
	}

</script>